export default function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8" data-testid={testid}>
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl text-foreground">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-2 max-w-xl leading-relaxed">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
